var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.047,
    height: 24,
    viewBox: "0 0 23.047 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Edit_icon_1",
    "data-name": "Edit icon 1",
    transform: "translate(1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_114",
    "data-name": "Trazado 114",
    d: "M3799.649,1853.487l-13.4,13.577-.485,4.125,4.326-1.355,12.417-13.309Z",
    transform: "translate(-3780.461 -1853.487)",
    fill: "#d7664a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_115",
    "data-name": "Trazado 115",
    d: "M3784.788,1867.01h-11.727v17.239H3790.5v-13",
    transform: "translate(-3773.061 -1861.248)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.d7662fd214775cbaf1963f92a24f55f1.svg";
export { ForwardRef as ReactComponent };